/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_No_Events_ToastInputs */



/**
* | output |
* | --- |
* | "No events in the current group." |
*
* @param {Error_Nav_No_Events_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_events_toast = /** @type {((inputs?: Error_Nav_No_Events_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Events_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun evenement dans le groupe actuel.")
	if (locale === "de") return /** @type {LocalizedString} */ ("In der aktuellen Gruppe sind keine Ereignisse verzeichnet.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento nel gruppo corrente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В текущей группе нет событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay eventos en el grupo actual.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("当前组内没有事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在のグループにはイベントがありません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान समूह में कोई इवेंट नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não há eventos no grupo atual.")
	return /** @type {LocalizedString} */ ("No events in the current group.")
});